import 'moment/min/locales';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/image_manager.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/save.min.js';
import 'froala-editor/js/plugins/track_changes.min.js';
import 'froala-editor/js/plugins/url.min.js';

import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { Dialog } from '@angular/cdk/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { Overlay, OverlayModule, RepositionScrollStrategy } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
import { RouterModule } from '@angular/router';
import { SignalRConfiguration, SignalRModule } from '@henkkelder/ng2-signalr';
import { LoaderModule } from '@loader/loader.module';
import { WjGridModule } from '@mescius/wijmo.angular2.grid';
import { WjGridFilterModule } from '@mescius/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@mescius/wijmo.angular2.grid.grouppanel';
import { WjGridSearchModule } from '@mescius/wijmo.angular2.grid.search';
import { WjInputModule } from '@mescius/wijmo.angular2.input';
import { WjNavModule } from '@mescius/wijmo.angular2.nav';
import { DatetimeAdapter, MTX_DATETIME_FORMATS, MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { MomentDatetimeAdapter, MomentDatetimeModule, MTX_MOMENT_DATETIME_FORMATS } from '@ng-matero/extensions-moment-adapter';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TopBarUserMenuDialogAboutComponent } from '@platform/components/top-bar-user-menu/top-bar-user-menu-dialog-about';
import { AssignmentsOverlayComponent } from '@playbook/components/assignments-overlay/assignments-overlay';
import { ExternalActionsOverlayComponent } from '@playbook/components/external-actions-overlay/external-actions-overlay';
import { ClipboardSourceChooserComponent } from '@suite/platform/components/clipboard/modal/clipboard-source-chooser-modal.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import moment from 'moment';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { LinkyModule } from 'ngx-linky';
import { NgxUploaderModule } from 'ngx-uploader';

import { AssignmentComponent } from './components/assignments-list/assignment/assignment';
import { StAssignmentCondensedComponent } from './components/assignments-list/st-assignment-condensed/st-assignment-condensed';
import { AttachmentsListComponent } from './components/attachments-list/attachments-list';
import { AttachmentErrorComponent } from './components/attachments-list/modal/error/attachment-error';
import { AttachmentRenameComponent } from './components/attachments-list/modal/rename/attachment-rename';
import { AvatarBigComponent, AvatarBigHorizontalNameComponent, AvatarBigVerticalNameComponent } from './components/avatar/avatar-big';
import { AvatarMediumComponent, AvatarMediumHorizontalNameComponent, AvatarMediumVerticalNameComponent } from './components/avatar/avatar-medium';
import { AvatarSmallComponent, AvatarSmallHorizontalNameComponent, AvatarSmallVerticalNameComponent } from './components/avatar/avatar-small';
import { AvatarComponent } from './components/avatar/avatar-upload';
import { EnpsComponent } from './components/base/enps-component';
import { EnpsRouterComponent } from './components/base/enps-router-component';
import { EnpsSinglePageComponent } from './components/base/enps-single-page';
import { ListComponent } from './components/base/list';
import { CastObjectItemComponent } from './components/cast-object-item/cast-object-item';
import { CastObjectsComponent } from './components/cast-objects/cast-objects';
import { CreateNewTemplateComponent } from './components/create-new-template/create-new-template';
import { DateRangePagerComponent } from './components/date-range-pager/date-range-pager';
import { FilterComponent } from './components/filter/filter/filter';
import { FilterListComponent } from './components/filter/filter-list/filter-list';
import { FilterManageTeamMembersComponent } from './components/filter/filter-manage-team-members/filter-manage-team-members';
import { FilterPlanningViewsComponent } from './components/filter/filter-planning-views/filter-planning-views';
import { ViewstatesListComponent } from './components/filter/viewstates-list/viewstates-list';
import { IconComponent } from './components/icon/icon';
import { StoryIconComponent } from './components/icon/story-icon';
import { ListDropDownComponent } from './components/list-drop-down/list-drop-down';
import { MapViewComponent } from './components/map-view/map-view';
import { AlertModalComponent } from './components/modal/alert/alert';
import { ConfirmationModalComponent } from './components/modal/confirmation/confirmation';
import { ErrorModalComponent } from './components/modal/error/error';
import { FatalModalComponent } from './components/modal/fatal/fatal';
import { ModalComponent } from './components/modal/modal/modal';
import { PagerComponent } from './components/pager/pager';
import { SearchBoxComponent } from './components/search-box/search-box';
import { SimpleSearchBoxComponent } from './components/search-box/simple-search-box/simple-search-box';
import { SimpleSearchBoxAutocompleteComponent } from './components/search-box/simple-search-box-autocomplete/simple-search-box-autocomplete';
import { EditorMenuComponent } from './components/st-editor-menu/editor-menu/editor-menu.component';
import { StAccordionComponent } from './components/st-expansion-panel/st-accordion.component';
import { StExpansionPanelComponent } from './components/st-expansion-panel/st-expansion-panel.component';
import { StRoGridComponent } from './components/st-ro-grid/st-ro-grid';
import { StaffIDListTooltipComponent } from './components/staff-id-list-tooltip/staff-id-list-tooltip';
import { StoryItemComponent } from './components/stories-list/story-item/story-item';
import { TileColumnComponent } from './components/tile-column/tile-column';
import { TileGroupColumnComponent } from './components/tile-group-column/tile-grop-column';
import { TileViewComponent } from './components/tile-view/tile-view';
import { StTopicItemComponent } from './components/topic-item/st-topic-item.component';
import { TopicItemCondensedComponent } from './components/topic-item-condensed/topic-item-condensed';
import { CastViewStateComponent } from './components/view-state/cast-view-state';
import { DiscoverViewStateComponent } from './components/view-state/discover-view-state';
import { LiveViewStateComponent } from './components/view-state/live-view-state';
import { PlaybookViewStateComponent } from './components/view-state/playbook-view-state';
import { ViewStateComponent } from './components/view-state/view-state';
import { AddressFormComponent } from './controls/address-form/address-form';
import { AssignmentIconListComponent } from './controls/assignment-icon-list/assignment-icon-list';
import { AssignmentTypeComponent } from './controls/assignment-type/assignment-type';
import { CheckBoxComponent } from './controls/check-box/check-box';
import { CheckListComponent } from './controls/check-list/check-list';
import { ComboBoxComponent } from './controls/combo-box/combo-box';
import { DatePickerComponent } from './controls/date-picker/date-picker';
import { DateRangePickerComponent } from './controls/date-range-picker/date-range-picker';
import { DateTimePickerComponent } from './controls/date-time-picker/date-time-picker';
import { DateTimePickerCustomHeaderComponent } from './controls/date-time-picker-custom-header/date-time-picker-custom-header';
import { DateTimeRangeComponent } from './controls/date-time-range/date-time-range';
import { DeskComponent } from './controls/desk/desk';
import { DurationFieldComponent } from './controls/duration-field/duration-field';
import { DurationSecondsInputFieldComponent } from './controls/duration-seconds-input-field/duration-seconds-input-field';
import { RundownButtonComponent } from './controls/rundown-button/rundown-button';
import { SpecialComponent } from './controls/special/special';
import { SpecialCostComponent } from './controls/special/special-cost/special-cost';
import { RichTextEditorComponent } from './controls/st-rich-text-editor/st-rich-text-editor';
import { StTextAreaComponent } from './controls/st-text-area/st-text-area';
import { StTextAreaOverlayComponent } from './controls/st-text-area/text-area-overlay/st-text-area-overlay';
import { StaffIDListComponent } from './controls/staff-id-list/staff-id-list';
import { StaffIDListMultipleComponent } from './controls/staff-id-list/staff-id-list-multiple';
import { StatusComponent } from './controls/status/status';
import { StoryIconListComponent } from './controls/story-icon-list/story-icon-list';
import { StoryOutputTypeComponent } from './controls/story-output-type/story-output-type';
import { TagsAutocompleteComponent } from './controls/tags/tags-autocomplete';
import { TextFieldComponent } from './controls/text-field/text-field';
import { TextFieldCurrencyComponent } from './controls/text-field/text-field-currency/text-field-currency';
import { ToggleControlComponent } from './controls/toggle-button/toggle-control';
import { TopicButtonComponent } from './controls/topic-button/topic-button';
import { TopicTypeComponent } from './controls/topic-type/topic-type';
import { TreeComponent } from './controls/tree/tree';
import { TreeChecklistComponent } from './controls/tree-checklist/tree-checklist';
import { DateTime } from './data-models/complex-types/date-time';
import { AssignmentIconDirective } from './directives/assignment-icon';
import { CardLeftBorderDirective } from './directives/card-left-border';
import { DifferentSizesVirtualScrollDirective } from './directives/different-sizes-virtual-scroll';
import { EnpsDroppableDirective } from './directives/enps.droppable';
import { FooterDirective } from './directives/footer-directive';
import { HeaderDirective } from './directives/header-directive';
import { ItemDirective } from './directives/item-directive';
import { OnlyNumberDirective } from './directives/only-number';
import { ClickStopPropagationDirective, EnterStopPropagationDirective, SpaceStopPropagationDirective } from './directives/stop-propagation';
import { StoryIconDirective } from './directives/story-icon';
import { TopicCardTypeColorDirective } from './directives/topic-card-type-color';
import { TopicIconDirective } from './directives/topic-icon';
import { FormattedTextPipe } from './pipes/formatted-text';
import { FullNamePipe } from './pipes/full-name.pipe';
import { HighlightPipe } from './pipes/highlight';
import { IsArrayPipe } from './pipes/is-array';
import { SortPipe } from './pipes/sort';
import { TopicTypePipe } from './pipes/topic-type';
import { UnsafePipe } from './pipes/unsafe';
import { JwtIncerceptor } from './services/interceptors/http-interceptor';
import { WireMediaComponent } from './wire-media/wire-media.component';

export function getSignalRConfiguration() {
    const signalrConfiguration = new SignalRConfiguration();
    return signalrConfiguration;
}

export function scrollFactory(overlay: Overlay): () => RepositionScrollStrategy {
    return () => overlay.scrollStrategies.reposition();
}

export class ENPSDatetimeAdapter extends MomentDatetimeAdapter {
    format(date: moment.Moment): string {
        date.locale(moment.locale());
        return DateTime.formatMomentToLocalDateTimeString(date);
    }
}

export class ENPSDateAdapter extends MomentDateAdapter {
    format(date: moment.Moment): string {
        return DateTime.formatMomentToLocalDateString(date);
    }
}

@NgModule({
    declarations: [
        EnpsComponent,
        EnpsRouterComponent,
        EnpsSinglePageComponent,
        DateTimePickerCustomHeaderComponent,
        StExpansionPanelComponent,
        StAccordionComponent,
        TextFieldComponent,
        StTextAreaOverlayComponent,
        TextFieldCurrencyComponent,
        DatePickerComponent,
        StTextAreaComponent,
        ComboBoxComponent,
        CheckListComponent,
        CheckBoxComponent,
        ToggleControlComponent,
        SpecialComponent,
        TreeComponent,
        TreeChecklistComponent,
        IconComponent,
        StoryIconComponent,
        SpecialCostComponent,
        DateRangePickerComponent,
        DateRangePagerComponent,
        DateTimeRangeComponent,
        PagerComponent,
        ModalComponent,
        AlertModalComponent,
        FatalModalComponent,
        ErrorModalComponent,
        ConfirmationModalComponent,
        ViewStateComponent,
        PlaybookViewStateComponent,
        DiscoverViewStateComponent,
        LiveViewStateComponent,
        CastViewStateComponent,
        CreateNewTemplateComponent,
        AvatarComponent,
        AvatarBigComponent,
        AvatarBigHorizontalNameComponent,
        AvatarBigVerticalNameComponent,
        AvatarMediumComponent,
        AvatarMediumHorizontalNameComponent,
        AvatarMediumVerticalNameComponent,
        AvatarSmallHorizontalNameComponent,
        AvatarSmallVerticalNameComponent,
        AvatarSmallComponent,
        ListDropDownComponent,
        TileColumnComponent,
        TileGroupColumnComponent,
        TileViewComponent,
        FilterComponent,
        FilterListComponent,
        FilterPlanningViewsComponent,
        FilterManageTeamMembersComponent,
        ViewstatesListComponent,
        CastObjectsComponent,
        CastObjectItemComponent,
        StaffIDListComponent,
        StaffIDListTooltipComponent,
        TagsAutocompleteComponent,
        HighlightPipe,
        IsArrayPipe,
        FormattedTextPipe,
        SortPipe,
        OnlyNumberDirective,
        UnsafePipe,
        TopicTypePipe,
        FullNamePipe,
        StaffIDListMultipleComponent,
        AddressFormComponent,
        AttachmentsListComponent,
        EnpsDroppableDirective,
        AttachmentRenameComponent,
        AttachmentErrorComponent,
        ListComponent,
        MapViewComponent,
        StTopicItemComponent,
        TopicItemCondensedComponent,
        StatusComponent,
        DeskComponent,
        TopicTypeComponent,
        AssignmentComponent,
        StoryItemComponent,
        StAssignmentCondensedComponent,
        AssignmentTypeComponent,
        HeaderDirective,
        ItemDirective,
        FooterDirective,
        SearchBoxComponent,
        SimpleSearchBoxComponent,
        SimpleSearchBoxAutocompleteComponent,
        CardLeftBorderDirective,
        AssignmentIconDirective,
        StoryIconDirective,
        TopicCardTypeColorDirective,
        TopicIconDirective,
        ClipboardSourceChooserComponent,
        ClickStopPropagationDirective,
        SpaceStopPropagationDirective,
        EnterStopPropagationDirective,
        DifferentSizesVirtualScrollDirective,
        DateTimePickerComponent,
        TopBarUserMenuDialogAboutComponent,
        ExternalActionsOverlayComponent,
        AssignmentsOverlayComponent,
        RichTextEditorComponent,
        StRoGridComponent,
        WireMediaComponent,
        DurationFieldComponent,
        AssignmentIconListComponent,
        StoryIconListComponent,
        StoryOutputTypeComponent,
        TopicButtonComponent,
        RundownButtonComponent,
        DurationSecondsInputFieldComponent,
        EditorMenuComponent,
    ],
    imports: [
        RouterModule,
        FormsModule,
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        ReactiveFormsModule,
        NgxUploaderModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        SignalRModule.forRoot(getSignalRConfiguration),
        DragDropModule,
        CurrencyMaskModule,
        // TreeModule,
        MatTreeModule,
        MatCheckboxModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatBadgeModule,
        BidiModule,
        MatChipsModule,
        MatTabsModule,
        MatTableModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatToolbarModule,
        MatInputModule,
        MatDialogModule,
        MatListModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonToggleModule,
        MatGridListModule,
        MatRadioModule,
        MtxDatetimepickerModule,
        MtxNativeDatetimeModule,
        MomentDatetimeModule,
        MomentDateModule,
        MatPaginatorModule,
        MatStepperModule,
        GoogleMapsModule,
        MatProgressBarModule,
        MatRippleModule,
        LinkyModule,
        LoaderModule,
        OverlayModule,
        MatExpansionModule,
        NgOptimizedImage,
        ScrollingModule,
        MatTooltipModule,
        LayoutModule,
        A11yModule,
        PushPipe,
        LetDirective,
        WjGridModule,
        WjInputModule,
        WjGridGrouppanelModule,
        WjGridFilterModule,
        WjNavModule,
        WjGridSearchModule,
    ],
    providers: [
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above', showDelay: 1000 } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto', appearance: 'outline' } },
        { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtIncerceptor,
            multi: true,
        },
        { provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, useValue: { hideSingleSelectionIndicator: true } },
        { provide: DatetimeAdapter, useClass: ENPSDatetimeAdapter },
        { provide: DateAdapter, useClass: ENPSDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MTX_DATETIME_FORMATS, useValue: MTX_MOMENT_DATETIME_FORMATS },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        Dialog,
        HighlightPipe,
        IsArrayPipe,
    ],
    exports: [
        RouterModule,
        FormsModule,
        CommonModule,
        DragDropModule,
        HttpClientModule,
        HttpClientJsonpModule,
        ReactiveFormsModule,
        NgxUploaderModule,
        CurrencyMaskModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        OverlayModule,
        MatTreeModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatChipsModule,
        MatTabsModule,
        MatTableModule,
        MatSlideToggleModule,
        MatBadgeModule,
        BidiModule,
        TileColumnComponent,
        TileGroupColumnComponent,
        MatInputModule,
        MatDialogModule,
        MatListModule,
        MatSidenavModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonToggleModule,
        MatGridListModule,
        MatRadioModule,
        MtxDatetimepickerModule,
        GoogleMapsModule,
        MatPaginatorModule,
        MatStepperModule,
        MatProgressBarModule,
        MatRippleModule,
        LinkyModule,
        LoaderModule,
        EnpsComponent,
        EnpsRouterComponent,
        EnpsSinglePageComponent,
        DateTimePickerCustomHeaderComponent,
        SearchBoxComponent,
        SimpleSearchBoxComponent,
        SimpleSearchBoxAutocompleteComponent,
        StTextAreaOverlayComponent,
        TextFieldComponent,
        TextFieldCurrencyComponent,
        DatePickerComponent,
        StTextAreaComponent,
        ComboBoxComponent,
        CheckListComponent,
        CheckBoxComponent,
        SpecialComponent,
        TreeComponent,
        TreeChecklistComponent,
        IconComponent,
        StoryIconComponent,
        SpecialCostComponent,
        DateRangePickerComponent,
        DateRangePagerComponent,
        DateTimeRangeComponent,
        PagerComponent,
        StAccordionComponent,
        StExpansionPanelComponent,
        ModalComponent,
        AlertModalComponent,
        FatalModalComponent,
        ErrorModalComponent,
        ConfirmationModalComponent,
        ViewStateComponent,
        PlaybookViewStateComponent,
        DiscoverViewStateComponent,
        LiveViewStateComponent,
        CastViewStateComponent,
        CreateNewTemplateComponent,
        ToggleControlComponent,
        AvatarComponent,
        AvatarBigComponent,
        AvatarBigHorizontalNameComponent,
        AvatarBigVerticalNameComponent,
        AvatarMediumComponent,
        AvatarMediumHorizontalNameComponent,
        AvatarMediumVerticalNameComponent,
        AvatarSmallComponent,
        AvatarSmallHorizontalNameComponent,
        AvatarSmallVerticalNameComponent,
        ListDropDownComponent,
        TileViewComponent,
        MapViewComponent,
        FilterComponent,
        FilterListComponent,
        FilterPlanningViewsComponent,
        FilterManageTeamMembersComponent,
        ViewstatesListComponent,
        CastObjectsComponent,
        CastObjectItemComponent,
        StaffIDListComponent,
        StaffIDListTooltipComponent,
        TagsAutocompleteComponent,
        HighlightPipe,
        IsArrayPipe,
        FormattedTextPipe,
        SortPipe,
        OnlyNumberDirective,
        UnsafePipe,
        TopicTypePipe,
        FullNamePipe,
        StaffIDListMultipleComponent,
        AddressFormComponent,
        AttachmentsListComponent,
        EnpsDroppableDirective,
        AttachmentRenameComponent,
        AttachmentErrorComponent,
        HeaderDirective,
        ItemDirective,
        FooterDirective,
        CardLeftBorderDirective,
        AssignmentIconDirective,
        StoryIconDirective,
        TopicCardTypeColorDirective,
        TopicIconDirective,
        StTopicItemComponent,
        TopicItemCondensedComponent,
        MatTooltipModule,
        StatusComponent,
        DeskComponent,
        TopicTypeComponent,
        AssignmentComponent,
        StoryItemComponent,
        StAssignmentCondensedComponent,
        AssignmentTypeComponent,
        ClipboardSourceChooserComponent,
        MatExpansionModule,
        ClickStopPropagationDirective,
        SpaceStopPropagationDirective,
        EnterStopPropagationDirective,
        NgOptimizedImage,
        ScrollingModule,
        LayoutModule,
        DifferentSizesVirtualScrollDirective,
        A11yModule,
        DateTimePickerComponent,
        TopBarUserMenuDialogAboutComponent,
        ExternalActionsOverlayComponent,
        AssignmentsOverlayComponent,
        PushPipe,
        LetDirective,
        FroalaEditorModule,
        FroalaViewModule,
        RichTextEditorComponent,
        WjGridModule,
        WjInputModule,
        WjGridGrouppanelModule,
        WjGridFilterModule,
        WjNavModule,
        WjGridSearchModule,
        StRoGridComponent,
        WireMediaComponent,
        DurationFieldComponent,
        AssignmentIconListComponent,
        StoryIconListComponent,
        StoryOutputTypeComponent,
        TopicButtonComponent,
        RundownButtonComponent,
        DurationSecondsInputFieldComponent,
        EditorMenuComponent,
    ],
})
export class StorytellingCommonModule {}
